<div class="filter-bar" *ngIf="vm$ | async as vm">
  <div class="filter-bar__row">
    <div class="filter-bar__toggles">
      <mat-button-toggle-group
        *ngIf="vm.showPeriod"
        class="filter-bar__group"
        aria-label="Period"
        #periodGroup="matButtonToggleGroup"
        [value]="vm.period"
        (change)="onPeriodChange($event)"
      >
        <mat-button-toggle
          #periodToggle
          *ngFor="let option of periodOptions; trackBy: trackByValue"
          [value]="option.value"
        >
          {{ option.label }}
        </mat-button-toggle>
        <mat-button-toggle #periodToggle [value]="customPeriod" (change)="onCustomPeriodActivate()">
          Custom
        </mat-button-toggle>
      </mat-button-toggle-group>
      <mat-button-toggle-group
        class="filter-bar__group"
        aria-label="Scope"
        [value]="vm.scope"
        (change)="onScopeChange($event)"
      >
        <mat-button-toggle *ngFor="let option of scopeOptions; trackBy: trackByValue" [value]="option.value">
          {{ option.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <span class="filter-bar__label" *ngIf="vm.label">{{ vm.label }}</span>
  </div>
</div>
